// Branded loading state — gold ball spinner + optional quiet label.
// Drop-in replacement for the raw grey "Loading…" strings that read as a
// stalled web page next to the app's skeletons and shimmer states.
import React from "react";

const GOLD = "#E2DD9F";

export default function BamLoading({ label = "", pad = 28, size = 22, style }) {
  return (
    <div aria-label={label || "Loading"} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, padding: pad, ...style }}>
      <style>{`@keyframes bamLoadSpin { to { transform: rotate(360deg); } }`}</style>
      <span aria-hidden style={{ width: size, height: size, borderRadius: "50%", border: `2px solid ${GOLD}33`, borderTopColor: GOLD, display: "inline-block", animation: "bamLoadSpin .8s linear infinite" }} />
      {label && <span style={{ fontSize: 12.5, color: "#888", fontFamily: "'DM Sans', -apple-system, sans-serif" }}>{label}</span>}
    </div>
  );
}
